//Updateplayers pictures, links, numbers and names
import vitor from "./photos/ vitor.jpg";
import arthur from "./photos/arthur.jpg";
import be from "./photos/be.jpg";
import carlos from "./photos/carlos.jpg";
import clovis from "./photos/clovis.jpg";
import davia from "./photos/davia.jpg";
import davis from "./photos/davis.jpg";
import inigo from "./photos/inigo.jpg";
import diego from "./photos/diego.jpg";
import elijah from "./photos/elijah.jpg";
import enzo from "./photos/enzo.jpg";
import erik from "./photos/erik.jpg";
import feijo from "./photos/feijo.jpg";
import felipao from"./photos/felipao.jpg";
import fred from "./photos/fred.jpg"
import gabriel from "./photos/gabriel.jpg";
import gui from "./photos/gui.jpg";
import guido from "./photos/guido.jpg";
import henri from "./photos/henri.jpg";
import indaias from "./photos/indaias.jpg";
import isaac from "./photos/isaac.jpg";
import japa from "./photos/japa.jpg";
import joca from "./photos/joca.jpg";
import jola from "./photos/jola.jpg";
import jon from "./photos/jon.jpg";
import kg from "./photos/kg.jpg";
import lethabo from "./photos/lethabo.jpg";
import lucas from "./photos/lucas.jpeg";
import matheus from "./photos/matheus.jpg";
import miguel from "./photos/miguel.jpg";
import nicollas from "./photos/nicollas.jpg";
import pacheco from "./photos/pacheco.jpeg";
import pg from "./photos/pg.jpg";
import raph from "./photos/raph.jpg";
import raul from "./photos/raul.jpg";
import renan from "./photos/renan.jpg";
import stoll from "./photos/stoll.jpg";
import theo from "./photos/theo.jpg";
import thomas from "./photos/thomas.jpg";
import varanda from "./photos/varanda.jpg";
import yan from "./photos/yan.jpg";
import cyllas from "./photos/cyllas.jpg";
import renan2 from "./photos/renan2.jpg";
import alberto from "./photos/alberto.jpg";
import pedro from "./photos/pedro.jpg";

export const coach = [
    {
        p_name:"Alberto",
        l_name: "Nostre",
        number: 0,
        city: "Santos",
        cnt: "Brazil 🇧🇷",
        insta: "",
        video: "",
        src: alberto,
        position: "Assistant Coach"
    },

    {
        p_name:"Cyllas",
        l_name: "Martins",
        number: 0,
        city: "São Paulo",
        cnt: "Brazil 🇧🇷",
        insta: "",
        video: "",
        src: cyllas,
        position: "Assistant Coach"
    },

    {
        p_name:"Lucas",
        l_name: "Almeida",
        number: 0,
        city: "São Paulo",
        cnt: "Brazil 🇧🇷",
        insta: "",
        video: "",
        src: lucas,
        position: "Head Coach"
    },

    {
        p_name:"Pedro",
        l_name: "Galícia",
        number: 0,
        city: "Michoacan",
        cnt: "Mexico 🇲🇽",
        insta: "",
        video: "",
        src: pedro,
        position: "Goalkeeper Coach"
    },

    {
        p_name:"Renan",
        l_name: "Mougenot",
        number: 0,
        city: "Curitiba",
        cnt: "Brazil 🇧🇷",
        insta: "",
        video: "",
        src: renan2,
        position: "Assistant Coach"
    },


    {
        p_name:"",
        l_name: "",
        number: "",
        city: "",
        cnt: "",
        insta: "",
        video:"",
        src: "",
        position: ""
    }
]



export const goalies = [
    {
        p_name:"Bernardo",
        l_name: "Manzano",
        number: 0,
        city: "Palmas",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/bemanzano_/",
        video:"https://youtu.be/6LMQUFhtUuE",
        src: be,
        position: ""
    },

    {
        p_name:"Iñigo",
        l_name: "Castro",
        number: 0,
        city: "Manila",
        cnt: "Philippines 🇵🇭",
        insta: "https://www.instagram.com/inigocastro13/",
        video:"https://youtu.be/Xz4e07NdmHA",
        src:inigo,
        position: ""
    },

    {
        p_name:"Diego",
        l_name: "Wittler",
        number: 0,
        city: "Porto Alegre",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/diegowittler/",
        video:"https://www.youtube.com/watch?v=1xlbRbaFQb8",
        src: diego,
        position: ""
    }

]

export const def = [
    {
        p_name:"Carlos",
        l_name: "Neto",
        number: 0,
        city: "Brasília",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/_carlosamn_06/",
        video:"https://drive.google.com/drive/u/0/mobile/folders/1JzomX_T7Oinm0hFATgtxlpl_rV1j7iaw",
        src: carlos,
        position: ""
    },

    {
        p_name:"Elijah",
        l_name: "Changaya",
        number: 0,
        city: "Blantyre",
        cnt: "Malawi 🇲🇼",
        insta: "https://www.instagram.com/sobopapi/",
        video:"https://www.fieldlevel.com/app/profile/elijah.changaya/soccermen/videos/1567066",
        src: elijah,
        position: ""
    },

    {
        p_name:"Enzo",
        l_name: "Mello",
        number: 0,
        city: "Cuiabá",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/enzomell0/",
        video:"",
        src: "",
        position: ""
    },

    {
        p_name:"Enzo",
        l_name: "Passos",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/enzopasso_/",
        video:"https://youtu.be/5aDkF9o-j2M",
        src: enzo,
        position: ""
    },

    {
        p_name:"Gabriel",
        l_name: "Lemos",
        number: 0,
        city: "Belo Horizonte",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/gabriel_lemosp/",
        video:"",
        src: gabriel,
        position: ""
    },

    {
        p_name:"Guilherme",
        l_name: "Fleischfresser",
        number: 0,
        city: "Curitiba",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/guifleisch/",
        video:"",
        src: gui,
        position: ""
    },

    {
        p_name:"João Luis",
        l_name: "Castro",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/jl.castro_/",
        video:"https://www.youtube.com/watch?v=FmLnoXFfj3s",
        src: jola,
        position: ""
    },

    {
        p_name:"João Victor",
        l_name: "Guido",
        number: 0,
        city: "Vitória",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/joaovictorvieiraguido/",
        video:"",
        src: guido,
        position: ""
    },

    {
        p_name:"Jonatas",
        l_name: "Abreu",
        number: 0,
        city: "Manaus",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/jonn.highlights/",
        video:"",
        src:jon,
        position: ""
    },

    {
        p_name:"Kagiso",
        l_name: "Mathabatha",
        number: 0,
        city: "Pretoria",
        cnt: "South Africa 🇿🇦",
        insta: "https://www.instagram.com/askboutkg/",
        video:"https://drive.google.com/file/d/1T4r-FT72Nj2ZJ4BJSPZ53jLY0Dc3aA35/view?usp=drivesdk",
        src: kg,
        position: ""
    },

    {
        p_name:"Lucca",
        l_name: "Czamarka",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/lucca_nc/",
        video:"",
        src:pg,
        position: ""
    },

    {
        p_name:"Matheus",
        l_name: "Alvarenga",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/alvarengamatheus_/",
        video:"https://youtu.be/_3BL-z0xH3Y",
        src:matheus,
        position: ""
    },

    {
        p_name:"Miguel",
        l_name: "Stein",
        number: 0,
        city: "São Paulo",
        cnt: "Brazil",
        insta: "https://www.instagram.com/miguelstein_/",
        video:"https://m.youtube.com/watch?v=V9PfaKcHZTg",
        src:miguel,
        position: ""
    },

    {
        p_name:"Nicollas",
        l_name: "Seilhe",
        number: 0,
        city: "Rio de janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/nicollas.seilhe/",
        video:"",
        src:nicollas,
        position: ""
    },

    {
        p_name:"Rafael",
        l_name: "Gerardi",
        number: 0,
        city: "São Paulo",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/rafaelgerardi_/",
        video:"https://youtu.be/I-c1QT1GsJU",
        src:varanda,
        position: ""
    },

    {
        p_name:"Theo",
        l_name: "Luis",
        number: 0,
        city: "Belo Horizonte",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/theoluis_6/",
        video:"https://youtu.be/zmTGy1MiknY",
        src:theo,
        position: ""
    },

    {
        p_name:"Thomas",
        l_name: "Marins",
        number: 0,
        city: "Americana",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/thomasmarins/",
        video:"",
        src:thomas,
        position: ""
    },

    {
        p_name:"Yan",
        l_name: "Souza",
        number: 0,
        city: "Florianópolis",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/yan_simas06/",
        video:"https://youtu.be/US3gW1TlPw0",
        src:yan,
        position: ""
    }
]

export const mid = [
    {
        p_name:"Davi",
        l_name: "Aguiar",
        number: 0,
        city: "Maceió",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/davi_.aguiar/",
        video:"http://www.hudl.com/v/2HZ1rn",
        src: davia,
        position: ""
    },

    {
        p_name:"Davi",
        l_name: "Silva",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/davisilva.2006/",
        video:"",
        src: davis,
        position: ""
    },

    {
        p_name:"Frederico",
        l_name: "Wittler",
        number: 0,
        city: "Porto Alegre",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/fredwittler/",
        video:"",
        src: fred,
        position: ""
    },

    {
        p_name:"Henri",
        l_name: "Marques",
        number: 0,
        city: "Goiânia",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/henrinmarques_/",
        video:"https://youtu.be/fEvWmNgmHfU",
        src:henri,
        position: ""
    },

    {
        p_name:"João Pedro",
        l_name: "Stoll",
        number: 0,
        city: "São Paulo",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/jp_stoll/",
        video:"",
        src:stoll,
        position: ""
    },

    {
        p_name:"Joaquim",
        l_name: "Diniz",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/joaquimdiniz__/",
        video:"",
        src:joca,
        position: ""
    },

    {
        p_name:"Lethabo",
        l_name: "Hlakula",
        number: 0,
        city: "Pretoria",
        cnt: "South Africa 🇿🇦",
        insta: "https://www.instagram.com/lethabo5168/",
        video:"",
        src:lethabo,
        position: ""
    },

    {
        p_name:"Matheus",
        l_name: "Pacheco",
        number: 0,
        city: "Curitiba",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/matpachecoo_/",
        video:"https://youtu.be/a6u2uQ6z4Ts",
        src: pacheco,
        position: ""
    },

    {
        p_name:"Raphael",
        l_name: "Santana",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/raphinha.bueno/",
        video:"",
        src:raph,
        position: ""
    },

    {
        p_name:"Raul",
        l_name: "Sanseverino",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/raulsanseverino/",
        video:"",
        src:raul,
        position: ""
    },

    {
        p_name:"Vitor",
        l_name: "Martins",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/vt.martins_/",
        video:"",
        src: vitor,
        position: ""
    },

    {
        p_name:"",
        l_name: "",
        number: "",
        city: "",
        cnt: "",
        insta: "",
        video:"",
        src:"",
        position: ""
    }
    
]

export const fw = [
    {
        p_name:"Arthur",
        l_name: "Cartaxo",
        number: 0,
        city: "João Pessoa",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/_arthurcartaxo/",
        video:"https://youtu.be/S3fjc8WiBCg",
        src: arthur,
        position: ""
    },

    {
        p_name:"Clovis",
        l_name: "Kalisa",
        number: 0,
        city: "Kigali",
        cnt: "Rwanda 🇷🇼",
        insta: "https://www.instagram.com/_c.l.o.v.i.s_/",
        video:"",
        src: clovis,
        position: ""
    },

    {
        p_name:"Erik",
        l_name: "Zandonade",
        number: 0,
        city: "Vitória",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/erikzandonade/",
        video:"https://youtu.be/pJpPAWt19rw",
        src:erik,
        position: ""
    },

    {
        p_name:"Felipe",
        l_name: "Feijó",
        number: 0,
        city: "Rio de Janeiro",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/felipefeijocarpenter_/",
        video:"https://www.instagram.com/reel/CpimsX4N9Qq/?igshid=MDJmNzVkMjY=",
        src:feijo,
        position: ""
    },

    {
        p_name:"Felipe",
        l_name: "Rocha",
        number: 0,
        city: "São Paulo",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/feliperocha03/",
        video:"https://youtu.be/NCpm5qbrt6g",
        src:felipao,
        position: ""
    },

    {
        p_name:"Isaac",
        l_name: "Cubero",
        number: 0,
        city: "Alajuela",
        cnt: "Costa Rica 🇨🇷",
        insta: "https://www.instagram.com/sacocubero/",
        video:"",
        src:isaac,
        position: ""
    },

    {
        p_name:"Nicolas",
        l_name: "Lie",
        number: 0,
        city: "Indaiatuba",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/nicolaslie__/",
        video:"",
        src:indaias,
        position: ""
    },

    {
        p_name:"Renan",
        l_name: "Maestri",
        number: 0,
        city: "Vitória",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/renan_maestri/",
        video:"https://youtu.be/Ld6xZX5HrBs",
        src:renan,
        position: ""
    },

    {
        p_name:"Vitor",
        l_name: "Yoshida",
        number: 0,
        city: "São Paulo",
        cnt: "Brazil 🇧🇷",
        insta: "https://www.instagram.com/vitoryoshidaa/",
        video:"https://youtu.be/8cUTWSr9GQI",
        src: japa,
        position: ""
    }
    
]
